module.exports = __webpack_public_path__ + "img/img05.55fadf94.png";